// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:5px}::-webkit-scrollbar-thumb{background:#fafafa}::-webkit-scrollbar-thumb:hover{background:#eee}", ""]);
// Exports
module.exports = exports;
